import Vue from "vue";
import Vuex from "vuex";
import Router from 'vue-router'
import request from "@/utils/request";
import { judeEnv } from "../util.js";
import { unionBy } from 'lodash'
import Cookies from "js-cookie";
import router from '@/router'
Vue.use(Vuex);
const projectName = "/api/blade-platform";

export default new Vuex.Store({
  state: {
    config: null,
    userInfo: null,
    pageIndex: 1,
    DormitoryList: null,
    positionObj: null,
  },
  mutations: {
    SET_positionObj (state, result) {
      state.positionObj = result
    },
    SET_CONFIG(state, result) {
      const st = state;
      st.config = result;
    },
    SET_userInfo(state, result) {
      const st = state;
      st.userInfo = result;
    },
    SET_pageIndex(state, result) {
      const st = state;
      st.pageIndex = result;
    },
    SET_DormitoryList (state, result) {
      if (state.DormitoryList === null || result === null) {
        state.DormitoryList = result
      } else {
        state.DormitoryList = unionBy([...state.DormitoryList, ...result], 'id')
      }
    }
  },
  actions: {
    setConfig({ commit }) {
      return request({
        url: `config.json?date=${new Date().getTime()}`,
        method: "get"
      }).then(res => {
        commit("SET_CONFIG", res.data);
        request.defaults.baseURL = res.data.BASE_URL + res.data.PROJECT_NAME;
        return res;
      });
    },
    /**
     * 登录
     * @param {Vm} Vm vue对象
     * @param {stirng} key_id
     * @param {string | number} type 1学生 2教职工
     */
    async login({ commit }, params) {
      // 设置环境
      Vue.prototype.environment = judeEnv();
      console.log(params.Vm.environment.isFengChao,'判断');
      if (params.Vm.environment.isFengChao) {
        // 调用JS-API登录
        await params.Vm.$cjc.login({ appKey: "0000" });
        if(window.location.hash.indexOf('ProjectDetails') == -1 && window.location.hash.indexOf('HistoryProject') == -1 && window.location.hash.indexOf('userAgreement') == -1 && window.location.hash.indexOf('privacyPolicy') == -1 ){
          params.Vm.$cjc.hiddenNavigation();
        }
        // const userInfo = await params.Vm.$cjc.getUserInfo()
        const userInfo = await params.Vm.$cjc.getEDUUserInfo();
        const phoneInfo = await params.Vm.$cjc.phoneInfo();
        const data = Object.assign(userInfo.result, phoneInfo.result);
        console.log("userInfo__", data);
        commit("SET_userInfo", data);
        return userInfo;
      } else if (params.Vm.environment.isXXMH) {
        // 获取RSA用以标识从信息门户进入
        const RSA = Cookies.get("combStr");
        const userInfo = await params.Vm.$store.dispatch("getUserInfoByRSA", {
          combStr: RSA
        });
        return userInfo;
      } else {
        console.log('当前路由=>',router.app._route.name);
        let name = router.app._route.name
        if (name != 'userAgreement' && name != 'privacyPolicy') {
          alert("请将客户端升级至最新版~");
        }
        console.log(Router.path);
      }
    },
    /**
     * 从信息门户进入 根据RSA获取数据
     */
    async getUserInfoByRSA({ commit }, params) {
      const userInfo = await api.getUserInfoByRSA(params);
      return userInfo;
    },
    // 机器人智能问答
    robotSearchLucene({ commit }, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/searchLucene`,
        method: "post",
        data
      }).then(res => {
        return Promise.resolve(res);
      });
    },
    // 猜你想找列表
    questionList({ commit }, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/showList`,
        method: "post",
        data
      }).then(res => {
        return Promise.resolve(res);
      });
    },
    // 移动端异常反馈/功能建议
    saveQuestionFeedbackInfo({ commit }, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/feedBack/saveQuestionFeedbackInfo`,
        method: "post",
        data
      }).then(res => {
        return Promise.resolve(res);
      });
    },
    // 机器人智能问答处--点击进入服务
    enterService({ commit }, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/enterService`,
        method: "post",
        data
      }).then(res => {
        return Promise.resolve(res);
      });
    },
    // 【机器人】获取机器人分类选择栏
    questionTypeList({ commit }) {
      return request({
        url: `${projectName}/nobody/aiquestion/selectList`,
        method: "get"
      }).then(res => {
        return Promise.resolve(res);
      });
    },
    // 根据类型分类查看全部问题
    getQuestionListByType({ commit }) {
      return request({
        url: `${projectName}/nobody/aiquestion/getQuestionListByType`,
        method: "get"
      }).then(res => Promise.resolve(res));
    },
    //详情
    themeArticleDetail(actions, data) {
      return request({
        url: `${projectName}/nobody/app/themeArticle/detail`,
        method: "post",
        data
      });
    },
    //详情
    getAppWebsiteInfo(actions, data) {
      return request({
        url: `${projectName}/nobody/public/getAppWebsiteInfo`,
        method: "get",
      });
    },
    //详情
    themeArticleHistory(actions, data) {
      return request({
        url: `${projectName}/themeArticle/history/1`,
        method: "post",
        data
      });
    },
    //用户协议隐私政策
    getAppUserPrivacy(actions, data) {
      return request({
        url: `${projectName}/nobody/index/getAppUserPrivacy`,
        method: "post",
        data
      });
    },
    // 获取问候语
    getAiquestionGreet(actions, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/greet`,
        method: "get",
      });
    },
    // 获取机器人配置
    getRobotConfig(actions, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/baseInfo`,
        method: "get",
      });
    },
    // 获取猜你想问列表
    getAiquestionWantAnswer(actions, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/wantAnswer`,
        method: "get",
      });
    },
    // 点击问题，记录用户提问
    recordQuestion(actions, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/recordQuestion`,
        method: "post",
        data,
      });
    },
    // 是否解决
    aiquestionIsSolve(actions, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/isSolve`,
        method: "post",
        data,
      });
    },
    // 常见问题
    recommendLIst(actions, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/recommendLIst`,
        method: "get",
      });
    },
    // 搜索问题
    searchQuestion(actions, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/app/searchQuestion`,
        method: "post",
        data,
      });
    },
    // 异常反馈列表
    feedbackList(actions, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/feedback/list`,
        method: "post",
        data,
      });
    },
    // 全部问题-分类
    questionType(actions, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/questionType`,
        method: "get",
      });
    },
    
    // 全部问题-分类下的列表
    getQuestionList(actions, data) {
      return request({
        url: `${projectName}/nobody/aiquestion/question/type`,
        method: "post",
        data
      });
    },
    // 通过服务id查询所属服务
    findServiceInfo(actions, data) {
      return request({
        url: `${projectName}/nobody/app/findServiceInfo`,
        method: "post",
        data,
      });
    },
    // 未登录时查看办事指南（通用）
    clientGuideInfo (actions, data) {
      return request({
        url: `${projectName}/nobody/app/clientGuideInfo`,
        method: 'post',
        data
      })
    },
  }
});
